import React from 'react';
import Markup from 'components/Markup';
import { pushSearchEvent } from 'utils/analytics';

import * as styles from './MobileSearchSuggestions.module.scss';

export default function MobileSearchSuggestions({
  className,
  showSuggestions,
  suggestions,
  handleItemClick,
}) {
  const handleSuggestionClick = value => {
    handleItemClick(value);
    pushSearchEvent({
      action: 'click_on_suggestion',
      label: value,
      deviceType: 'Mobile',
      pageUrl: window.location.href,
    });
  };
  return (
    <div className={className}>
      {showSuggestions && (
        <div className={styles.list}>
          {suggestions.map(item => (
            <Markup
              tag="button"
              key={item}
              className={styles.listItem}
              onClick={() => handleSuggestionClick(item)}
            >
              {item}
            </Markup>
          ))}
        </div>
      )}
    </div>
  );
}
